import { sagas as slotsCalendarSagas } from 'framework/modules/slotManagement/pages/LiveTimeSlotView/store';
import { sagas as slotsTemplateEditSagas } from 'framework/modules/slotManagement/pages/SlotsTemplatesEdit/redux';

export default [...slotsCalendarSagas, ...slotsTemplateEditSagas];
